import { Extension } from '@tiptap/core';

const INDENT_STEP_PX = 40;
const MAX_INDENT_PX = 200;

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      indentParagraph: () => ReturnType;
      outdentParagraph: () => ReturnType;
    };
  }
}

export const Indent = Extension.create({
  name: 'indent',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph'],
        attributes: {
          indent: {
            default: 0,
            parseHTML: (el) => {
              const ml = (el as HTMLElement).style.marginLeft;
              if (!ml) return 0;
              return parseInt(ml, 10) || 0;
            },
            renderHTML: (attrs) => {
              if (!attrs['indent']) return {};
              return { style: `margin-left: ${attrs['indent'] as number}px` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      indentParagraph:
        () =>
        ({ state, dispatch }) => {
          const { selection } = state;
          const tr = state.tr;
          let modified = false;

          state.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
            if (node.type.name === 'paragraph') {
              const current = (node.attrs['indent'] as number) || 0;
              const next = Math.min(current + INDENT_STEP_PX, MAX_INDENT_PX);
              tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: next });
              modified = true;
            }
          });

          if (modified && dispatch) dispatch(tr);
          return modified;
        },

      outdentParagraph:
        () =>
        ({ state, dispatch }) => {
          const { selection } = state;
          const tr = state.tr;
          let modified = false;

          state.doc.nodesBetween(selection.from, selection.to, (node, pos) => {
            if (node.type.name === 'paragraph') {
              const current = (node.attrs['indent'] as number) || 0;
              const next = Math.max(current - INDENT_STEP_PX, 0);
              tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: next });
              modified = true;
            }
          });

          if (modified && dispatch) dispatch(tr);
          return modified;
        },
    };
  },
});
